<template>
  <v-card
    class="d-flex pa-2 ma-2 flex-column"
    :style="{
      height: 'fit-content',
      flex: '1',
      'background-color': cardColor,
      color: textColor,
    }"
  >
    <div class="d-flex pa-2 flex-row" v-show="display">
      <h3 style="flex-grow: 1">
        <slot name="header">{{ title }}</slot>
      </h3>
      <v-btn icon @click="display = !display">
        <v-icon>{{ display ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="display">
        <v-divider />
        <div class="d-flex pa-2 py-6 flex-row">
          <slot>Data not found.</slot>
        </div>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    cardColor: {
      type: String,
      default: null,
    },
    textColor: {
      type: String,
      default: null,
    },
    displayed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      display: this.displayed,
    };
  },
};
</script>
